<template>
  <el-form ref="form" label-width="140px" :rules="rules" :model="configForm">
    <el-row :gutter="10">
      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="columns || 8">
        <el-form-item label="任务初次排查时间" prop="initialInvestigationTime">
          <el-date-picker
            size="small"
            v-model="configForm.initialInvestigationTime"
            :disabled="disabled"
            :class="columns ? '' : '!w-full'"
            type="date"
            placeholder="请输入任务初次排查时间"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="columns || 8">
        <el-form-item label="任务排查截止时间" prop="deadlineForTime">
          <el-date-picker
            size="small"
            v-model="configForm.deadlineForTime"
            :disabled="disabled"
            :class="columns ? '' : '!w-full'"
            type="date"
            placeholder="请输入任务排查截止时间"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="columns || 8">
        <el-form-item label="执行人员" prop="deadlinePersonId">
          <MultiplePersonSelect
            v-model="configForm.deadlinePersonId"
            :disabled="disabled"
          ></MultiplePersonSelect>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="24" :md="24" :lg="24">
        <el-form-item label="执行时间" prop="checkList">
          <div class="flex justify-start">
            <div class="!mr-20px">
              <el-checkbox
                :indeterminate="isIndeterminate"
                v-model="checkAll"
                :disabled="disabled"
                @change="handleCheckAllChange"
                >全选</el-checkbox
              >
            </div>
            <el-checkbox-group v-model="configForm.checkList" @change="handleWeekCheck">
              <el-checkbox
                v-for="item in list"
                :disabled="disabled"
                :key="item.value"
                :label="item.value"
                >{{ item.label }}</el-checkbox
              >
            </el-checkbox-group>
          </div>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
        <el-form-item prop="timeArr">
          <el-time-picker
            :disabled="disabled"
            is-range
            value-format="HH:mm:ss"
            v-model="configForm.timeArr"
            range-speparator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            placeholder="选择时间范围"
          ></el-time-picker>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
        <el-form-item label="任务分配状态" prop="planStatus">
          <el-switch
            v-model="configForm.planStatus"
            :disabled="disabled"
            :active-value="true"
            :inactive-value="false"
          ></el-switch>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import dayjs from 'dayjs'
import { UserApi } from '@wiz-api/abp-identity'
import MultiplePersonSelect from '@/components/safety/FormSelect/MultiplePersonSelect'

const userApi = new UserApi()

export default {
  name: 'task-unit-config',
  components: {
    MultiplePersonSelect,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    columns: {
      type: Number,
      default: null,
    },
    oper: {
      type: String,
      default: 'batch',
    },
    // 单个设置当前行
    currentRow: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    const validateDate = (rule, value, callback) => {
      if (!this.configForm.deadlineForTime) {
        callback(new Error('请选择任务截止时间'))
      } else if (
        this.configForm.deadlineForTime &&
        this.configForm.initialInvestigationTime &&
        dayjs(`${this.configForm.deadlineForTime} 00:00:00`).unix() <=
          dayjs(`${this.configForm.initialInvestigationTime} 23:59:59`).unix()
      ) {
        callback(new Error('任务截至时间必须大于初次任务生成时间'))
      } else {
        callback()
      }
    }
    return {
      pickerOptions: {
        disabledDate(v) {
          return v.getTime() < new Date() - 1000 * 3600 * 24
        },
      },
      userList: [],
      checkAll: false,
      isIndeterminate: false,
      configForm: {
        timeArr: null,
        initialInvestigationTime: undefined,
        deadlineForTime: undefined,
        planStatus: true,
        checkList: [],
        deadlinePersonId: undefined,
      },
      list: [
        {
          label: '周一',
          value: 1,
        },
        {
          label: '周二',
          value: 2,
        },
        {
          label: '周三',
          value: 3,
        },
        {
          label: '周四',
          value: 4,
        },
        {
          label: '周五',
          value: 5,
        },
        {
          label: '周六',
          value: 6,
        },
        {
          label: '周日',
          value: 7,
        },
      ],
      rules: {
        initialInvestigationTime: [
          { required: true, message: '请选择任务初次排查时间', trigger: ['blur'] },
        ],
        deadlineForTime: [{ required: true, validator: validateDate, trigger: ['blur'] }],
        checkList: [
          {
            required: true,
            type: 'array',
            message: '至少选择一个执行时间',
            trigger: ['change', 'blur'],
          },
        ],
        deadlinePersonId: [
          { required: true, message: '请选择执行人员', trigger: ['change', 'blur'] },
        ],
        timeArr: [
          { type: 'array', required: true, message: '请选择执行时间段', trigger: ['blur'] },
        ],
      },
    }
  },
  mounted() {
    this.getUserList()
    // 单个任务设置才需要处理数据并回显
    if (this.oper !== 'batch') {
      this.handleRowData()
    }
    this.initCheckBoxStatus(this.oper)
  },
  methods: {
    // 处理数据,显示详情
    handleRowData() {
      _.forEach(this.currentRow, (item) => {
        // 处理自定义时段
        if (item.startTime && item.endTime) {
          const startTime = item.startTime
          const endTime = item.endTime
          this.configForm.timeArr = [startTime, endTime]
        } else {
          this.configForm.timeArr = null
        }
        // 处理选中的执行周期
        if (item.executeCycle) {
          this.configForm.checkList = _.map(item.executeCycle.split(','), (ele) => {
            return Number(ele)
          })
        }
        // 处理人员
        if (item.deadlinePersonId) {
          this.configForm.deadlinePersonId = item.deadlinePersonId
        } else {
          this.configForm.deadlinePersonId = undefined
        }
        this.configForm.planStatus =
          item.planStatus !== null && item.planStatus !== undefined ? !!item.planStatus : true
        this.configForm.initialInvestigationTime =
          item.initialInvestigationTime && dayjs(item.initialInvestigationTime).format('YYYY-MM-DD')
        this.configForm.deadlineForTime =
          item.deadlineForTime && dayjs(item.deadlineForTime).format('YYYY-MM-DD')
      })
    },

    // 处理数据,用于保存
    handleSaveData() {
      _.forEach(this.currentRow, (item) => {
        // 处理sorting不能为空
        item.sorting = 'desc'
        // 处理自定义时段,并格式化
        if (this.configForm.timeArr && this.configForm.timeArr.length === 2) {
          item.startTime = this.configForm.timeArr[0]
          item.endTime = this.configForm.timeArr[1]
        } else {
          item.startTime = undefined
          item.endTime = undefined
        }
        // 处理选中的执行周期
        if (this.configForm.checkList && this.configForm.checkList.length > 0) {
          item.executeCycle = this.configForm.checkList.join(',')
        }
        // 处理人员
        if (this.configForm.deadlinePersonId) {
          item.deadlinePersonId = this.configForm.deadlinePersonId
        } else {
          item.deadlinePersonId = undefined
        }

        item.planStatus = this.configForm.planStatus
        item.initialInvestigationTime =
          this.configForm.initialInvestigationTime &&
          dayjs(this.configForm.initialInvestigationTime).format('YYYY-MM-DD HH:mm:ss')
        item.deadlineForTime = this.configForm.deadlineForTime
          ? `${dayjs(this.configForm.deadlineForTime).format('YYYY-MM-DD')} 23:59:59`
          : undefined
      })
      return this.currentRow
    },
    // 获取用户列表
    async getUserList() {
      const [err, res] = await userApi.getList({
        skipCount: 0,
        maxResultCount: 999,
      })
      if (!err) {
        this.userList = res.items
      }
    },
    // 全选
    handleCheckAllChange(val) {
      const checkIds = _.map(this.list, (item, index) => {
        return item.value
      })
      this.configForm.checkList = val ? checkIds : []
      this.isIndeterminate = false
      this.checkAll = val
    },
    // 单个选中
    handleWeekCheck(value) {
      const checkCount = value.length
      this.checkAll = checkCount === this.list.length
      this.isIndeterminate = checkCount > 0 && checkCount < this.list.length
    },
    /**
     * 初始化数据，单个选中以及全部选中样式渲染
     * oper batch 批量 single 单个编辑
     */
    initCheckBoxStatus(oper) {
      if (oper === 'batch') {
        this.checkAll = true
        this.configForm.checkList = _.map(this.list, (item, index) => {
          return item.value
        })
      } else {
        this.checkAll = this.configForm.checkList.length === this.list.length
        this.isIndeterminate =
          this.configForm.checkList.length > 0 &&
          this.configForm.checkList.length < this.list.length
      }
    },
    // 提交表单
    submitForm() {
      let isValid = false
      this.$refs.form.validate((valid) => {
        if (valid) {
          isValid = true
        }
      })
      return isValid
    },
  },
}
</script>

<style></style>
